import React from 'react';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import CategoryGuidesSection from './CategoryGuidesSection';
import { TREKKING_HUB } from '../../data/touristCultureData';

function TrekkingHubPage() {
	const hub = TREKKING_HUB;

	return (
		<KnowledgeHubLayout
			touristSection="plan"
			touristCurrent="Trekking"
			planStepId="trekking"
			hideRelated
			seo={(
				<Seo
					title="Trekking in Nepal — Routes, Permits & Seasons"
					path="/trekking"
					description="Complete guide to trekking in Nepal — Everest Base Camp, Annapurna, Langtang, permits, fitness, teahouse culture, and how to choose your route."
				/>
			)}
			hero={{
				image: hub.hero,
				eyebrow: 'Discover Nepal',
				title: hub.title,
				lead: hub.lead,
			}}
			quickFacts={hub.quickFacts}
			intro={{
				title: 'The Himalaya on foot',
				text: 'Everything you need to choose a trek — on one page.',
				body: 'Nepal has routes for every fitness level. Read the sections below, then follow our guided Everest journey if EBC is your goal.',
			}}
			faqs={hub.faqs}
		>
			<DiscoverySection eyebrow="Guide" title="Trekking essentials">
				{hub.sections.map((s, i) => (
					<div key={s.id} id={s.id} className="info-card arrival-step-card" style={{ marginBottom: '1.25rem' }}>
						<div className="info-card__body">
							<span className="arrival-step-card__num">Section {i + 1}</span>
							<h3 className="info-card__title">{s.question}</h3>
							<p className="info-card__text">{s.answer}</p>
							{s.tips && s.tips.length > 0 && (
								<div className="arrival-tips">
									<p className="arrival-tips__label">Traveler tips</p>
									<ul>{s.tips.map((t) => <li key={t}>{t}</li>)}</ul>
								</div>
							)}
						</div>
					</div>
				))}
			</DiscoverySection>
			<CategoryGuidesSection
				category="trekking"
				title="Trekking guides"
				intro="Articles from our knowledge library — permits, teahouse trekking, route choice, and more."
				alt
			/>
		</KnowledgeHubLayout>
	);
}

export default TrekkingHubPage;
